module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "u-relative o-list--none o-list--inline u-align-center u-index--5"
  }, _vm._l((_vm.contentGlobal.partners), function(partner) {
    return _c('li', {
      staticClass: "o-list__item u-marg-x-lg u-marg-t-md"
    }, [_c('a', {
      staticClass: "c-partner",
      attrs: {
        "href": partner.url,
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "c-partner__img",
      attrs: {
        "src": partner.img,
        "alt": partner.name,
        "title": partner.name
      },
      on: {
        "load": _vm._onContentLoaded
      }
    })])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a2dcbd0"}!./src/scripts/components/app-partners/template.html
// module id = 929
// module chunks = 0